module.exports = __webpack_public_path__ + "img/swidish_pine_list.f8c420fa.jpg";